module.exports = __webpack_public_path__ + "img/icon-form-textbox.42b00f44.svg";